import { DateComparatorFilter } from './controls/formatters';

export const IST_OFFSET = 5.5 * 60 * 60 * 1000;
export const leadInputData = {
  pageSize: parseInt(process.env.REACT_APP_LEAD_PAGESIZE),
  pageNumber: 1,
  columnName: 'UpdatedDateTime',
  orderType: 'desc',
  filterJson: null,
  searchText: null,
  generalRecordVisibility: null,
};
export const leadTeamVisibilityInputData = {
  pageSize: parseInt(process.env.REACT_APP_LEAD_PAGESIZE),
  pageNumber: 1,
  columnName: 'UpdatedDateTime',
  orderType: 'desc',
  filterJson: null,
  searchText: null,
  teamRecordVisibility: null,
  teamId: null,
};
export const leadBucketVisibilityInputData = {
  pageSize: parseInt(process.env.REACT_APP_LEAD_PAGESIZE),
  pageNumber: 1,
  columnName: 'UpdatedDateTime',
  orderType: 'desc',
  filterJson: null,
  searchText: null,
  bucketRecordVisibility: null,
  bucketId: null,
};
export const campaignInputData = {
  pageSize: parseInt(process.env.REACT_APP_DEFAULT_PAGESIZE),
  pageNumber: 1,
  columnName: 'UpdatedDateTime',
  orderType: 'desc',
  filterJson: null,
  searchText: null,
};
export const contactInputData = {
  pageSize: parseInt(process.env.REACT_APP_DEFAULT_PAGESIZE),
  pageNumber: 1,
  columnName: 'UpdatedDateTime',
  orderType: 'desc',
  filterJson: null,
  searchText: null,
};
export const ticketInputData = {
  pageSize: parseInt(process.env.REACT_APP_DEFAULT_PAGESIZE),
  pageNumber: 1,
  columnName: 'UpdatedDateTime',
  orderType: 'desc',
  filterJson: null,
  searchText: null,
};
export const opportunityInputData = {
  pageSize: parseInt(process.env.REACT_APP_DEFAULT_PAGESIZE),
  pageNumber: 1,
  columnName: 'UpdatedDateTime',
  orderType: 'desc',
  filterJson: null,
  searchText: null,
};
export const accountInputData = {
  pageSize: parseInt(process.env.REACT_APP_DEFAULT_PAGESIZE),
  pageNumber: 1,
  columnName: 'UpdatedDateTime',
  orderType: 'desc',
  filterJson: null,
  searchText: null,
};
export const meetingInputData = {
  pageSize: parseInt(process.env.REACT_APP_DEFAULT_PAGESIZE),
  pageNumber: 1,
  columnName: 'UpdatedDateTime',
  orderType: 'desc',
  filterJson: null,
};
export const callInputData = {
  pageSize: parseInt(process.env.REACT_APP_DEFAULT_PAGESIZE),
  pageNumber: 1,
  columnName: 'UpdatedDateTime',
  orderType: 'desc',
  filterJson: null,
};
export const salesOrderInputData = {
  pageSize: parseInt(process.env.REACT_APP_DEFAULT_PAGESIZE),
  pageNumber: 1,
  columnName: 'UpdatedDateTime',
  orderType: 'desc',
  filterJson: null,
  searchText: null,
};
export const invoiceInputData = {
  pageSize: parseInt(process.env.REACT_APP_DEFAULT_PAGESIZE),
  pageNumber: 1,
  columnName: 'UpdatedDateTime',
  orderType: 'desc',
  filterJson: null,
  searchText: null,
};
export const productInputData = {
  pageSize: parseInt(process.env.REACT_APP_DEFAULT_PAGESIZE),
  pageNumber: 1,
  columnName: 'UpdatedDateTime',
  orderType: 'desc',
  filterJson: null,
  searchText: '',
};
export const priceInputData = {
  pageSize: parseInt(process.env.REACT_APP_DEFAULT_PAGESIZE),
  pageNumber: 1,
  columnName: 'UpdatedDateTime',
  orderType: 'desc',
  filterJson: null,
  searchText: '',
};
export const quoteInputData = {
  pageSize: parseInt(process.env.REACT_APP_DEFAULT_PAGESIZE),
  pageNumber: 1,
  columnName: 'UpdatedDateTime',
  orderType: 'desc',
  filterJson: null,
  searchText: '',
};
export const policyQuoteInputData = {
  pageSize: parseInt(process.env.REACT_APP_DEFAULT_PAGESIZE),
  pageNumber: 1,
  columnName: 'createdOn',
  orderType: 'desc',
  filterJson: null,
  searchText: '',
  generalRecordVisibility: null,
  lobState: null,
};
export const getSaleOrderDetailListInputData = {
  pageSize: parseInt(process.env.REACT_APP_DEFAULT_PAGESIZE),
  pageNumber: 1,
  columnName: '',
  orderType: 'desc',
  filterJson: null,
  searchText: '',
};
export const dropdownPayload = {
  pageSize: 50,
  pageNumber: 1,
  searchText: '',
};
export const dropdownPayloadCampaignLead = {
  pageSize: 2000,
  pageNumber: 1,
  searchText: '',
  module: 'Lead',
};
export const dropdownPayloadCampaignContact = {
  pageSize: 2000,
  pageNumber: 1,
  searchText: '',
  module: 'Contact',
};
export const auditLogInputData = {
  pageSize: parseInt(process.env.REACT_APP_DEFAULT_PAGESIZE),
  pageNumber: 1,
  columnName: 'CreatedDateTime',
  orderType: 'desc',
  filterJson: null,
  searchText: null,
};
export const productReferenceLookup = {
  type: ['Vendor', 'Manufacturer', 'ProductCategory'],
};
const currentYear = new Date().getFullYear();
export const filterParams = {
  comparator: DateComparatorFilter,
  minValidYear: 2000,
  maxValidYear: currentYear,
  inRangeFloatingFilterDateFormat: 'DD MM YYYY',
  buttons: ['apply', 'reset'],
  closeOnApply: true,
  suppressAndOrCondition: true,
  inRangeInclusive: true,
};
export const formattedMaxDate = (() => {
  const today = new Date();
  const nextYear = today.getFullYear() + 1; // Get the next year
  const maxDate = new Date(nextYear, 11, 31); // Set to December 31 of the next year
  return maxDate.toLocaleDateString('en-CA'); // Formats as 'YYYY-MM-DD'
})();
export const fixTimezoneOffset = (date) => {
  if (!date || !(date instanceof Date)) return '';
  // Adjust for timezone offset
  const adjustedDate = new Date(date.getTime() - date.getTimezoneOffset() * 60000);
  return adjustedDate.toISOString();
};

export const formatUSCurrency = (value) => {
  const amount = Number(value);
  if (value == null || isNaN(amount)) return '';

  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(amount);
};

export const currencyFormatterByField = (fieldName) => {
  return (params) => {
    const value = params?.data?.[fieldName];
    return formatUSCurrency(value);
  };
};

export const handleGridSearch = async ({
  searchValue,
  apiMethod, // Function to call the API (e.g., apiServices.getCampaignList)
  gridApiRef, // Reference to AG Grid API
  inputPayload = {}, // The base payload to start with
  setData, // State setter for result data
  setTotalCount, // State setter for count
  setLoading, // Optional loading state handler
  filterFieldName = 'filterJson', // Optional custom key for filters
}) => {
  const trimmedText = searchValue?.trim();
  if (!trimmedText) return;

  // const filterModel = inputPayload[filterFieldName]
  //   ? JSON.parse(inputPayload[filterFieldName])
  //   : {};

  const payload = {
    ...inputPayload,
    // [filterFieldName]: JSON.stringify(filterModel),
    pageNumber: 1,
    searchText: trimmedText,
  };

  try {
    gridApiRef.current?.showLoadingOverlay();
    if (setLoading) setLoading(true);

    const res = await apiMethod(payload);
    const dataList =
      res?.data?.campaign ||
      res?.data?.leads ||
      res?.data?.contacts ||
      res?.data?.product ||
      res?.data?.account ||
      [];

    setData(dataList);
    setTotalCount?.(res?.data?.totalCount || 0);

    if (!dataList.length) {
      gridApiRef.current?.showNoRowsOverlay();
    } else {
      gridApiRef.current?.hideOverlay();
    }
  } catch (error) {
    console.error('Search Error:', error);
    gridApiRef.current?.showNoRowsOverlay();
  } finally {
    if (setLoading) setLoading(false);
  }
};

// export const fixTimezoneOffset = (date) => {
//   if (!date || !(date instanceof Date)) return "";

//   // Get the current system date at midnight
//   const currentSystemDate = new Date();
//   currentSystemDate.setHours(0, 0, 0, 0);

//   // Adjust the provided date to local timezone at midnight
//   const adjustedDate = new Date(date.getTime() - date.getTimezoneOffset() * 60000);
//   adjustedDate.setHours(0, 0, 0, 0);

//   // Compare dates (at midnight) and return the appropriate value
//   if (adjustedDate.getTime() !== currentSystemDate.getTime()) {
//     return currentSystemDate.toISOString(); // Return current system date
//   }

//   return date.toISOString(); // Return the original date
// };
